<div style="display: flex;flex-flow: column;height: 100%;gap: 30px;" class="flex flex-col h-full">
  <!-- <app-head-o2 style="width: 100%;"></app-head-o2> -->
  <div class="flex flex-col pl-10 pr-10 pt-10">
    <!--**********Tab Menubar**********-->
    <div class="menu">
      <div style="display: flex;flex-flow: row;gap: 10px;flex: 1;justify-content: flex-end;">
        <div class="mat-button" style="gap: 10px;flex: 0 40%;">
          
          <mat-form-field style="display: flex;flex-flow: row;flex: 1" class="my-form-field" >
            <input autocomplete="off" type="text" matInput placeholder="คำค้นหา" matInput #input
              [(ngModel)]="searchForm.search" name="search" #search="ngModel" (keyup)="applyFilter($event)">
            <button matSuffix mat-icon-button aria-label="ค้นหา">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <!--**********Button search**********-->
        <button mat-raised-button color="accent" [matMenuTriggerFor]="myMenu">
          <div class="flex items-center">
            <span>เงื่อนไขการค้นหา</span>
            <mat-icon>expand_more</mat-icon>
          </div>
        </button>
        <!--**********Menu for button search**********-->
        <mat-menu #myMenu="matMenu" xPosition="before" class="my-menu">
          <div class="pl-2 pr-2" (click)="stopPropagation($event)">
            <div class="pl-2 pr-2">              
              <div class="flex flex-row">
                <div class="basis-full">
                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>วันเวลาที่ยื่นคำร้อง</mat-label>
                    <input matInput [matDatepicker]="picker1" [(ngModel)]="searchForm.selectedDate">
                    <mat-hint>YYYY/MM/DD</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 dateFormat="YYYY/MM/DD"></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>เลขที่ใบรับรอง</mat-label>
                    <input autocomplete="off" type="text" matInput placeholder="เลขที่ใบรับรอง" #input
                      [(ngModel)]="searchForm.ms24headno" name="ms24headno" #ms24headno="ngModel">
                  </mat-form-field>

                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>ผู้ส่งออก</mat-label>
                    <input autocomplete="off" type="text" matInput placeholder="ผู้ส่งออก" #input
                      [(ngModel)]="searchForm.companyname" name="companyname" #companyname="ngModel">
                  </mat-form-field>
                </div>
              </div>    
            </div>
              <div class="flex justify-end formm">
                <div>
                  <button type = "submit" mat-raised-button color="accent"  style="flex:0 50%;" (click)="loadData()">
                    ค้นหา
                  </button>
                </div>
              </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>
  <!--**********Table ietmtype Data**********-->
  <div class="mat-elevation-z8">
   <table mat-table  [dataSource]="dataSource" matSort > 
   
      <!--**********1.m24HeadNoResponse**********-->
      <ng-container matColumnDef="m24HeadNoResponse">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;" sortActionDescription="Sort by name" >เลขที่ใบรับรอง</th>
        <td mat-cell *matCellDef="let element"> {{element.m24HeadNoResponse}} </td>
      </ng-container>
      <!--**********2.Date**********-->
      <ng-container matColumnDef="dateOldResponse">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">
          วันเวลาที่ยื่นคำร้อง</th>
        <td mat-cell *matCellDef="let element"> {{(element.dateOldResponse | date:'yyyy-MM-dd hh:mm:ss') || '-'}} </td>
      </ng-container>
      <!--**********3.m24HeadCompanyNameResponse**********-->
      <ng-container matColumnDef="m24HeadCompanyNameResponse">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">
          ผู้ส่งออก</th>
        <td mat-cell *matCellDef="let element"> {{element.m24HeadCompanyNameResponse}} </td>
      </ng-container>
       <!--**********4.Catagory**********-->
       <ng-container matColumnDef="m24HeadDetailResponse">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">
          รายการ</th>
        <td mat-cell *matCellDef="let element"> {{element.m24HeadDetailResponse}} </td>
      </ng-container>
       <!--**********5.Status**********-->
       <ng-container matColumnDef="m24ShortStatusResponse">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">
          สถานะ</th>
        <td mat-cell *matCellDef="let element"> {{element.m24ShortStatusResponse}} </td>
      </ng-container>
      <!--**********5.Action button**********-->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <button mat-icon-button matTooltip="ยอมรับ" (click)="Adjustms24StatusType(element,'Complete')">
            <mat-icon>check_circle_outline</mat-icon>
          </button> 
          <button mat-icon-button matTooltip="ไม่ยอบรับ" (click)="Adjustms24StatusType(element,'Reject')">
            <mat-icon>highlight_off</mat-icon>
          </button> 
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
   <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>